const Spacing = {
  "0": "0rem",
  "25": "0.025rem",
  "125": "0.125rem",
  "250": "0.25rem",
  "500": "0.5rem",
  "650": "0.65rem",
  "750": "0.75rem",
  "875": "0.875rem",
  "1000": "1rem",
  "1125": "1.125rem",
  "1250": "1.25rem",
  "1500": "1.5rem",
  "1750": "1.75rem",
  "2000": "2rem",
  "2180": "2.1875rem",
  "2500": "2.5rem",
  "3000": "3rem",
  "3500": "3.5rem",
  "4000": "4rem",
  "4500": "4.5rem",
  "5000": "5rem",
  "6000": "6rem",
  "8000": "8rem",
  "10000": "10rem",
  "12500": "12.5rem",
  "18750": "18.75rem"
};
const ONE_PIXEL_REM = "0.065rem";
export {
  ONE_PIXEL_REM,
  Spacing
};
//# sourceMappingURL=spacing.es.js.map
